// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__lK29x","doubleBounce1":"Spinner_doubleBounce1__ejGF1","doubleBounce2":"Spinner_doubleBounce2__JizcQ","sk-bounce":"Spinner_sk-bounce__mSmXt"};